import { useCallback, useContext, useEffect, useMemo, useState, forwardRef } from 'react';
import { Box, ButtonBase, makeStyles } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import _, { isArray } from 'lodash';
import moment from 'moment';
import { AutoCompleteSelect } from '../../../components';
import {
  AdmIcon,
  CloseIcon,
  DropDownIcon,
  FilterIcon,
  FullScreenIcon,
  FullScreenOffIcon,
  NewSettingIcon,
} from '../../../components/Icon';
import { closeFullScreen, openFullScreen, updateBedStatusViewVal } from '../../../redux/actions';
import rou from '../../../router';
import { classNames, getArrayRandomKey } from '../../../utils';
import { bedStatusAPI } from '../../../apis';
import ChooseFilter from '../components/PopWindows/ChooseFilter';
import { bsFilterFunc } from '../components/BedStatusAll/filterFunc';
import { i18n } from '../../../language';
import { authNameE } from '../../../utils/userFuncs';
import logoIcon from '../../../static/images/logo.png';
import { BEDSTATUS_OUTSTANDING_TRANSFER_IN } from '../../../comm/constant';
import { LoginPop } from '../../../components/Login';
import { useCommandCentre } from '../../../utils/useCommandCentre';
import { ReactComponent as RedFYA } from '../../../static/images/RedFYA.svg';
import { ReactComponent as PWR } from '../../../static/images/PWR.svg';
import { ReactComponent as CommandCentreIcon } from '../../../static/images/CommandCentre.svg';
import { BedStatusStatisticContext } from '..';
import { bsTransferInRef } from '../components/InternalBooking';
import { bsAdmissionRef } from '../components/InternalBooking/Admission';
import { AutoLogoutBtn, MuteBtn } from '../../Admission/Actionable/ActionableHeader';
import { playAudio, useActionableSettings, useEnableServiceOrder } from '../../../utils/hooks';
import { BsAlertSrc } from '../../../utils/bsAlertUtil';
import RefreshButton from '../../../components/RefreshButton';
import { userRoleFunc } from '../../../utils/userRole';
import showPatientNameIcon from '../../../static/images/showPatientNameIcon.png';
import useCheckLogin from '../../../utils/useCheckLogin';
import { CUBICLE_VIEW, CUBICLE_VIEW2, PLAIN_VIEW } from '../../../redux/constant';
import SelectLocation from './Popups/SelectLocation';

const useStyles = makeStyles((theme) => ({
  header: ({ fullScreen, sso }) => ({
    width: '100%',
    // height: fullScreen ? '2.625rem' : '4.3rem',
    backgroundColor: '#fff',
    boxShadow: '0 1px 0 0 #e4e7eb',
    padding: '0.4rem 0.875rem',
    display: 'flex',
    alignItems: 'center',
    position: fullScreen ? 'unset' : 'sticky',
    top: fullScreen || sso ? '0' : '4.375rem',
    zIndex: 1,
    gridGap: '0.5rem',
    flexWrap: 'wrap',
  }),
  tab: ({ fullScreen }) => ({
    fontFamily: 'NotoSans-Bold',
    color: '#538fff',
    fontSize: fullScreen ? '1rem' : '0.875rem',
    lineHeight: 1.1,
  }),
  unSelectTab: {
    opacity: '0.4',
  },
  border: ({ fullScreen }) => ({
    height: '2rem',
    width: '0.063rem',
    backgroundColor: '#e4e7eb',
  }),
  tools: ({ fullScreen }) => ({
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem',

    [`@media (max-width: 1340px)`]: {
      display: 'none',
    },
  }),
  muteBtn: ({ fullScreen }) => ({
    color: '#538fff',
    fontSize: '1rem',
    fontFamily: 'NotoSans-Bold',
    border: fullScreen ? 'unset' : 'solid 1px #e4e7eb',
    borderRadius: '8px',
    height: fullScreen ? '2.625rem' : '2.938rem',
    padding: '0 0.563rem',
    display: 'flex',
    columnGap: '0.625rem',
  }),
  unMuteIcon: {
    fontSize: '1.5rem',
  },
  filterBtn: ({ fullScreen }) => ({
    color: '#7d86a9',
    fontSize: '0.857rem',
    fontFamily: 'NotoSans-Bold',
    border: fullScreen ? 'unset' : 'solid 1px #e4e7eb',
    borderRadius: '8px',
    height: fullScreen ? '2.625rem' : '2.938rem',
    padding: fullScreen ? '0' : '0 0.571rem',
    display: 'flex',
    columnGap: '0.571rem',
  }),
  filterIcon: {
    fontSize: '1.5rem',
    color: '#538fff',
  },
  settingBtn: ({ fullScreen }) => ({
    color: '#538fff',
    // border: fullScreen ? 'unset' : 'solid 1px #bad2ff',
    // borderRadius: '8px',
    height: fullScreen ? '2.625rem' : '2.938rem',
    padding: '0.285rem',
  }),
  settingIcon: {
    fontSize: '1.5rem',
  },
  versionBtn: ({ fullScreen }) => ({
    color: '#7d86a9',
    fontSize: '0.857rem',
    fontFamily: 'NotoSans-Bold',
    padding: '0 0.285rem',
    // border: fullScreen ? 'unset' : 'solid 0.063rem #e4e7eb',
    // borderRadius: '8px',
    // height: fullScreen ? '2.625rem' : '2.938rem',
    lineHeight: 1.1,
  }),
  fullScreenBtn: {
    marginLeft: '0.5rem',
    width: '2.938rem',
    height: '2.625rem',
    backgroundColor: '#538fff',
    color: '#fff',
  },
  filterBox: {
    display: 'flex',
    background: '#538fff',
    borderRadius: '0.5rem',
  },
  filterAll: {
    width: '6.25rem',
    height: '2.938rem',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontFamily: 'NotoSans-Medium',
    fontSize: '1rem',
    fontWeight: '500',
    color: '#fff',
  },
  filterIconAll: {
    width: '1.438rem',
    height: '1.438rem',
    color: '#fff',
    marginRight: '0.625rem',
  },
  closeIcon: {
    width: '1rem',
    height: '1rem',
    color: '#fff',
  },
  icon: {
    width: '1.875rem',
    height: '1.875rem',
  },
  value: {
    fontSize: '1.5rem',
    color: '#2E4469',
    fontWeight: 'NotoSans-Bold',
  },
  showNameBtn: {
    padding: '0.357rem 0.571rem',
    border: '1px solid #E4E7EB',
    background: '#BAD2FF',
    borderRadius: '8px',
  },
  showNameBtnActive: {
    background: '#538FFF',
  },
  patientNameIcon: {
    width: '1.5rem',
    height: '2.142rem',
  },
  switchViewBtn: {
    color: '#2E4469',
    cursor: 'pointer',
  },
  dropdownIcon: {
    fontSize: '0.875rem',
    color: theme.palette.primary.main,
  },
  dropDownList: {
    position: 'absolute',
    top: '3rem',
    left: 0,
    background: '#FFFFFF',
    display: 'flex',
    padding: '0.285rem 0',
    flexDirection: 'column',
    borderRadius: '0.625rem',
    boxShadow: '0 2px 10px 0 rgba(0, 0, 0, 0.1)',
  },
  dropDownItem: {
    color: '#2E4469',
    fontWeight: 300,
    cursor: 'pointer',
    padding: '0.571rem 1rem',
    width: '5.45rem',

    '&:hover': {
      color: '#538fff',
      background: '#f5faff',
    },
  },
  flexSpace: {
    display: 'block',
    minWidth: 0,
    flex: 1,

    [`@media (max-width: 1370px)`]: {
      display: 'none',
    },
  },
}));

const FullScreenButton = ({ fullScreen, handleFullScreen }) => {
  const classes = useStyles({ fullScreen });
  return fullScreen ? (
    <ButtonBase className={classes.fullScreenBtn} onClick={handleFullScreen}>
      <FullScreenOffIcon className={classes.settingIcon} />
    </ButtonBase>
  ) : (
    <ButtonBase className={classes.settingBtn} onClick={handleFullScreen}>
      <FullScreenIcon className={classes.settingIcon} />
    </ButtonBase>
  );
};

const Header = forwardRef(
  (
    {
      selectedTab,
      setSelectedTab,
      filter,
      setFilter,
      filterData,
      setFilterData,
      handleResetFilter,
      statusBottom,
      remarks,
      showPatientName = true,
      setShowPatientName,
    },
    ref
  ) => {
    const fullScreen = useSelector((state) => state.fullScreenReducer);
    const sso = useSelector((state) => state.ssoReducer);
    const classes = useStyles({ fullScreen, sso });
    const dispatch = useDispatch();
    const history = useHistory();
    const roleMap = useSelector((state) => state.roleMap);
    const rouList = useSelector((state) => state.rouList);
    const loginInfo = useSelector((state) => state.loginInfo);
    const { currentViewType, isCubicleV2 } = useSelector((state) => state.bedStatusView);
    const handleCommandCentre = useCommandCentre();
    const { statistic, setRefresh } = useContext(BedStatusStatisticContext);
    const AdmissionWorkflowReducer = useSelector((state) => state.AdmissionWorkflowReducer);
    const [actionableSetting] = useActionableSettings();
    const [displayCommandCentre, setDisplayCommandCentre] = useState(false);
    const [locationInfo, setLocationInfo] = useState({
      open: false,
      list: [],
    });
    const [wardLocOptions, setWardLocOptions] = useState([]);
    const { enableOrderService } = useEnableServiceOrder();
    const checkLogin = useCheckLogin();
    const [showSwitchDropdown, setShowSwitchDropdown] = useState(false);

    useEffect(() => {
      const shouldPlayAudio = () =>
        !actionableSetting.mute && !AdmissionWorkflowReducer && statistic.pendingFYACount > 0;

      if (shouldPlayAudio()) {
        playAudio(BsAlertSrc);
        const interval = setInterval(() => {
          playAudio(BsAlertSrc);
        }, 1000 * 20);

        return () => clearInterval(interval);
      }
    }, [actionableSetting.mute, AdmissionWorkflowReducer, statistic.pendingFYACount]);

    const [filterPopup, setFilterPopup] = useState(false);

    const handleFilterOpen = useCallback(
      (open) => () => {
        setFilterPopup(open);
      },
      []
    );

    const handleSubmitFilter = useCallback((data) => {
      setFilterData(data);
      setFilterPopup(false);
    }, []);

    const handleFullScreen = () => {
      if (fullScreen) {
        dispatch(closeFullScreen());
      } else {
        setShowPatientName(false);
        dispatch(openFullScreen());
      }
    };

    const handleSetting = () => {
      history.push(`/newBedstatus/setting/cubicle`);
    };

    const handlePreVersion = () => {
      history.push(rou.bedstatusRou.path);
      dispatch(closeFullScreen());
    };

    const handleSelectTab = (id) => () => {
      setSelectedTab(id);
      sessionStorage.setItem('bsType', id);
    };

    const handleFilter = useCallback(
      (type) => (e) => {
        setFilter((o) => ({ ...o, [type]: e }));
      },
      []
    );

    const getDefaultWardLocVal = (wardLocList, isNotShow) => {
      const SSO_WARD_LOCATION = sessionStorage.getItem('SSO_WARD_LOCATION');
      if (SSO_WARD_LOCATION) return SSO_WARD_LOCATION;
      if (isNotShow) {
        return wardLocList?.[0]?.value;
      } else {
        return 'All';
      }
    };

    const getWardLocationOptions = (wardLocList, isNotShow) => {
      let defaultList = [
        {
          text: 'All',
          value: 'All',
        },
      ];
      defaultList = isNotShow ? defaultList.slice(1) : defaultList;
      defaultList = defaultList.concat(wardLocList);
      setWardLocOptions(defaultList);
    };

    const getLocationList = useCallback(async () => {
      try {
        const { result } = await bedStatusAPI.getLocationList();
        let wardLocList = [];
        if (isArray(result) && result.length > 0) {
          wardLocList = _.orderBy(
            _.map(result, (item) => ({
              text: item.wardLocation,
              value: item.wardLocation,
            })),
            'text'
          );
        }
        const notShowAllOption = isCubicleV2 && wardLocList.length > 2;
        handleFilter('wardLocation')(getDefaultWardLocVal(wardLocList, notShowAllOption));
        getWardLocationOptions(wardLocList, notShowAllOption);
      } catch (error) {}
    }, [rouList, handleFilter, isCubicleV2]);

    const [isShowLoginPop, setIsShowLoginPop] = useState(false);
    const closeLoginPop = () => {
      setIsShowLoginPop(false);
    };
    const showLoginPop = () => {
      setIsShowLoginPop(true);
    };

    // const handleCommandCentre = async () => {
    //   const { token, tokenExp, refreshToken, refreshTokenExp } = await autoApi.refreshToken({
    //     refreshToken: loginInfo.refreshToken,
    //   });

    //   if (moment(refreshTokenExp).isAfter(moment())) {
    //     localStorage.setItem(
    //       LOGIN_INFO,
    //       JSON.stringify({ ...loginInfo, token, tokenExp, refreshToken, refreshTokenExp })
    //     );
    //     mutationUpdateOtherLoginInfo();
    //     dispatch(updateLoginInfoAction({ ...loginInfo, token, tokenExp, refreshToken, refreshTokenExp }));
    //     dispatch(openMask());
    //     const commandCentre = window.open(`${i18n.t('COMMOND_CENTRE_URL')}?token=${token}`);
    //     const timer = setInterval(() => {
    //       if (commandCentre.closed) {
    //         dispatch(closeMask());
    //         clearInterval(timer);
    //       }
    //     }, 500);
    //   } else {
    //     dispatch(updateLoginInfoAction({ ...loginInfo, flag: false }));
    //     showLoginPop();
    //   }
    // };

    const handleActionable = () => {
      history.push('/actionableBs?type=BS');
    };

    const handleCountButton = (tabValue, status) => (event) => {
      event.stopPropagation();

      if (selectedTab === tabValue) {
        if (tabValue === 1) {
          bsTransferInRef?.current?.selectTab?.(status);
        } else if (tabValue === 3) {
          bsAdmissionRef?.current?.selectTab?.(status);
        }
      } else {
        handleSelectTab(tabValue)();
        if (_.some(status, (item) => item === 'O')) {
          sessionStorage.setItem(
            BEDSTATUS_OUTSTANDING_TRANSFER_IN,
            JSON.stringify({
              startTime: moment()
                .subtract(tabValue === 1 ? 7 : 1, 'days')
                .format('yyyy-MM-DD 00:00:00'),
              stopTime: moment().add(1, 'days').format('yyyy-MM-DD 23:59:59'),
              status: status,
              noDate: false,
            })
          );
        } else {
          sessionStorage.setItem(
            BEDSTATUS_OUTSTANDING_TRANSFER_IN,
            JSON.stringify({
              startTime: null,
              stopTime: null,
              status: status,
              noDate: true,
            })
          );
        }
      }
    };

    const getCommandCentreDisplay = async () => {
      try {
        const { result } = await bedStatusAPI.getCommandCentreDisplay();
        setDisplayCommandCentre(result.isDisplay);
      } catch (error) {
        console.log(error);
      }
    };

    useEffect(() => {
      getCommandCentreDisplay();
    }, []);

    useEffect(() => {
      getLocationList();
    }, [getLocationList]);

    const getLocation = async () => {
      try {
        const { result } = await bedStatusAPI.getLocationList();
        if (result.length === 1) {
          handleCommandCentre(result[0]);
        } else if (result.length > 1) {
          setLocationInfo({
            open: true,
            list: result,
          });
        }
      } catch (error) {
        console.log(error);
      }
    };

    const handleShowPatientName = () => {
      if (checkLogin()) {
        setShowPatientName(!showPatientName);
      }
    };

    const viewList = [
      {
        text: PLAIN_VIEW,
        value: PLAIN_VIEW,
        onClick: handlePreVersion,
      },
      {
        text: CUBICLE_VIEW,
        value: CUBICLE_VIEW,
        onClick: () => dispatch(updateBedStatusViewVal({ currentViewType: CUBICLE_VIEW, isCubicleV2: false })),
      },
      {
        text: CUBICLE_VIEW2,
        value: CUBICLE_VIEW2,
        onClick: () => dispatch(updateBedStatusViewVal({ currentViewType: CUBICLE_VIEW2, isCubicleV2: true })),
      },
    ];
    const handleSwitchOnClick = (onClick) => {
      setShowSwitchDropdown(false);
      if (_.isFunction(onClick)) {
        onClick();
      }
    };
    const SwitchViewDropdown = () => {
      return (
        <Box className={classes.dropDownList}>
          {_.map(viewList, (item, index) => (
            <Box
              key={getArrayRandomKey(index, 'bed-status-switch-view-type-btn')}
              onClick={() => handleSwitchOnClick(item?.onClick)}
              className={classes.dropDownItem}
            >
              {item?.text}
            </Box>
          ))}
        </Box>
      );
    };

    const SwitchViewButton = () => {
      return (
        <Box position="relative">
          <Box
            className={classes.switchViewBtn}
            display="flex"
            alignItems="center"
            gridGap="0.285rem"
            onClick={() => setShowSwitchDropdown(!showSwitchDropdown)}
          >
            <Box maxWidth="3.43rem">{_.find(viewList, (item) => item?.value === currentViewType)?.text}</Box>
            <DropDownIcon className={classes.dropdownIcon} />
          </Box>

          {showSwitchDropdown && <SwitchViewDropdown />}
        </Box>
      );

      // return (
      //   <ButtonBase className={classes.versionBtn} onClick={handlePreVersion}>
      //     Plain
      //     <br />
      //     View
      //   </ButtonBase>
      // );
    };

    const HeaderRightMenu = () => {
      return selectedTab === 0 ? (
        <>
          {loginInfo.flag && !fullScreen && currentViewType === CUBICLE_VIEW2 && (
            <ButtonBase
              className={classNames(classes.showNameBtn, showPatientName && classes.showNameBtnActive)}
              onClick={handleShowPatientName}
            >
              <img className={classes.patientNameIcon} src={showPatientNameIcon} alt="show patient name icon" />
            </ButtonBase>
          )}
          <Box minWidth="3.928rem">
            <AutoLogoutBtn module="bedStatus" />
          </Box>
          <div className={classes.border} />
          <MuteBtn bedstatus={true} showBorder={false} />
          <div className={classes.border} />
          {bsFilterFunc.isSelectAll({ allData: filterData }) ? (
            <ButtonBase className={classes.filterBtn} onClick={handleFilterOpen(true)}>
              <FilterIcon className={classes.filterIcon} />
              {i18n.t('BEDSTATUS_FILTER')}
            </ButtonBase>
          ) : (
            <div className={classes.filterBox}>
              <ButtonBase className={classes.filterAll} onClick={handleFilterOpen(true)}>
                <FilterIcon className={classes.filterIconAll} />
                {i18n.t('BEDSTATUS_FILTER')}
              </ButtonBase>
              <ButtonBase style={{ padding: '0 1rem' }} onClick={handleResetFilter}>
                <CloseIcon className={classes.closeIcon} />
              </ButtonBase>
            </div>
          )}
          {fullScreen && !sso && <div className={classes.border} />}
          {!sso && (
            <AutoCompleteSelect
              height={fullScreen ? '2.625rem' : '2.938rem'}
              width="6rem"
              border={fullScreen ? 'unset' : ''}
              itemList={wardLocOptions}
              value={filter.wardLocation}
              onChange={handleFilter('wardLocation')}
            />
          )}
          {!sso && <div className={classes.border} />}
          {!sso && <SwitchViewButton />}
          {roleMap?.[authNameE.bedStatus_edit_bed_status_module_setting] && !sso && (
            <>
              {!sso && <div className={classes.border} />}
              <ButtonBase className={classes.settingBtn} onClick={handleSetting}>
                <NewSettingIcon className={classes.settingIcon} />
              </ButtonBase>
            </>
          )}
          {!sso && <div className={classes.border} />}
          {!sso && <FullScreenButton fullScreen={fullScreen} handleFullScreen={handleFullScreen} />}
        </>
      ) : (
        <>
          <AutoLogoutBtn module="bedStatus" />
          <MuteBtn bedstatus={true} />
          {roleMap?.[authNameE.bedStatus_edit_bed_status_module_setting] && (
            <>
              <div className={classes.border} />
              <ButtonBase className={classes.settingBtn} onClick={handleSetting}>
                <NewSettingIcon className={classes.settingIcon} />
              </ButtonBase>
            </>
          )}
        </>
      );
    };

    return (
      <>
        <div ref={ref} className={classes.header}>
          <RefreshButton handleRefresh={() => setRefresh((o) => !o)} />
          <div className={classes.border} />
          {sso ? (
            <>
              <img src={logoIcon} alt="Ward Place" style={{ width: '2.625rem' }} />
              <div className={classes.tab}> Ward Place Bed Status </div>
            </>
          ) : (
            <>
              {fullScreen && <img src={logoIcon} alt="Ward Place" style={{ width: '2.625rem' }} />}
              <ButtonBase onClick={handleSelectTab(0)}>
                <div className={selectedTab === 0 ? classes.tab : classNames(classes.tab, classes.unSelectTab)}>
                  Bed
                  <br />
                  Status
                </div>
              </ButtonBase>

              {userRoleFunc?.getIsShowAdmission() && (
                <>
                  {AdmissionWorkflowReducer && (
                    <>
                      <div className={classes.border} />
                      <Box
                        display="flex"
                        alignItems="center"
                        style={{ gap: '0.5rem', cursor: 'pointer' }}
                        onClick={handleSelectTab(3)}
                      >
                        <div className={selectedTab === 3 ? classes.tab : classNames(classes.tab, classes.unSelectTab)}>
                          E-Adm.
                        </div>
                        <ButtonBase onClick={handleCountButton(3, ['PWA'])}>
                          <Box
                            display="flex"
                            alignItems="center"
                            gridGap="0.25rem"
                            p="0.5rem"
                            borderRadius="0.571rem"
                            bgcolor={statistic.pendingWardAckCount > 0 ? '#fff3bb' : '#FFF'}
                          >
                            <RedFYA className={classes.icon} />
                            <div className={classes.value}>{statistic.pendingWardAckCount}</div>
                          </Box>
                        </ButtonBase>
                        <ButtonBase onClick={handleCountButton(3, ['PWR'])}>
                          <Box
                            display="flex"
                            alignItems="center"
                            gridGap="0.25rem"
                            p="0.5rem"
                            borderRadius="0.571rem"
                            bgcolor={statistic.pendingWardReadyCount > 0 ? '#fff3bb' : '#FFF'}
                          >
                            <PWR className={classes.icon} />
                            <div className={classes.value}>{statistic.pendingWardReadyCount}</div>
                          </Box>
                        </ButtonBase>
                        <ButtonBase onClick={handleCountButton(3, ['O'])}>
                          <Box
                            display="flex"
                            alignItems="center"
                            gridGap="0.25rem"
                            p="0.5rem"
                            borderRadius="0.571rem"
                            bgcolor={statistic.eAdmOutstandingCount > 0 ? '#fff3bb' : '#FFF'}
                          >
                            <Box
                              display="flex"
                              alignItems="center"
                              justifyContent="center"
                              width="1.875rem"
                              height="1.875rem"
                              bgcolor="#00A8F9"
                              borderRadius="5px"
                            >
                              <AdmIcon style={{ fontSize: '1rem', color: '#FFF' }} />
                            </Box>
                            <div className={classes.value}>{statistic.eAdmOutstandingCount}</div>
                          </Box>
                        </ButtonBase>
                      </Box>
                    </>
                  )}
                  <div className={classes.border} />
                  <Box
                    display="flex"
                    alignItems="center"
                    style={{ gap: '0.5rem', cursor: 'pointer' }}
                    onClick={handleSelectTab(1)}
                  >
                    <div className={selectedTab === 1 ? classes.tab : classNames(classes.tab, classes.unSelectTab)}>
                      T/I
                      <br />
                      Req.
                    </div>
                    <ButtonBase onClick={handleCountButton(1, ['PFYA'])}>
                      <Box
                        display="flex"
                        alignItems="center"
                        gridGap="0.25rem"
                        p="0.5rem"
                        borderRadius="0.571rem"
                        bgcolor={statistic.pendingFYACount > 0 ? '#fff3bb' : '#FFF'}
                      >
                        <RedFYA className={classes.icon} />
                        <div className={classes.value}>{statistic.pendingFYACount}</div>
                      </Box>
                    </ButtonBase>
                    <ButtonBase onClick={handleCountButton(1, ['O', 'WR'])}>
                      <Box
                        display="flex"
                        alignItems="center"
                        gridGap="0.25rem"
                        p="0.5rem"
                        borderRadius="0.571rem"
                        bgcolor={statistic.outstandingCount > 0 ? '#fff3bb' : '#FFF'}
                      >
                        <Box
                          display="flex"
                          alignItems="center"
                          justifyContent="center"
                          width="1.875rem"
                          height="1.875rem"
                          bgcolor="#00A8F9"
                          borderRadius="5px"
                        >
                          <AdmIcon style={{ fontSize: '1rem', color: '#FFF' }} />
                        </Box>
                        <div className={classes.value}>{statistic.outstandingCount}</div>
                      </Box>
                    </ButtonBase>
                  </Box>
                  <div className={classes.border} />
                  <ButtonBase style={{ gap: '0.5rem' }} onClick={handleSelectTab(2)}>
                    <div className={selectedTab === 2 ? classes.tab : classNames(classes.tab, classes.unSelectTab)}>
                      T/O
                      <br />
                      Req.
                    </div>
                    {/* <ButtonBase onClick={handleCountButton(2, ['P', 'A', 'DL'])}>
                <Box
                  display="flex"
                  alignItems="center"
                  gridGap="0.25rem"
                  p="0.5rem"
                  bgcolor={statistic.pendingCount > 0 ? '#fff3bb' : '#FFF'}
                >
                  <Box
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    width="1.875rem"
                    height="1.875rem"
                    bgcolor="rgb(153,123,255)"
                    borderRadius="5px"
                  >
                    <AdmIcon style={{ fontSize: '1rem', color: '#FFF' }} />
                  </Box>
                  <div className={classes.value}>{statistic.pendingCount}</div>
                </Box>
              </ButtonBase> */}
                  </ButtonBase>
                  {AdmissionWorkflowReducer && (
                    <>
                      <div className={classes.border} />
                      <ButtonBase className={classNames(classes.tab, classes.unSelectTab)} onClick={handleActionable}>
                        Actionable
                      </ButtonBase>
                    </>
                  )}
                </>
              )}
              {enableOrderService && (
                <>
                  <div className={classes.border} />
                  <ButtonBase className={classes.tab} onClick={handleSelectTab(4)}>
                    <div className={selectedTab === 4 ? classes.tab : classNames(classes.tab, classes.unSelectTab)}>
                      Service
                    </div>
                  </ButtonBase>
                </>
              )}
              {loginInfo.flag && displayCommandCentre && (
                <>
                  <div className={classes.border} />
                  <ButtonBase className={classes.tab} onClick={getLocation}>
                    {/* <span style={{ opacity: '0.4' }}>CC</span> */}
                    <CommandCentreIcon style={{ width: '2.07rem', height: '100%', marginLeft: '0.5rem' }} />
                  </ButtonBase>
                </>
              )}
            </>
          )}
          <Box className={classes.flexSpace} />
          {!sso && <div className={classes.border} />}
          <HeaderRightMenu />
        </div>
        {filterPopup && (
          <ChooseFilter
            open={filterPopup}
            closePop={handleFilterOpen(false)}
            confirmHandle={handleSubmitFilter}
            allData={(() => {
              const result = {};
              [...remarks, ...statusBottom].forEach((item) => {
                result[item.typeName] = item;
              });
              return result;
            })()}
          />
        )}
        {isShowLoginPop && <LoginPop closehandle={closeLoginPop} submitHandle={closeLoginPop} />}
        {locationInfo.open && (
          <SelectLocation
            handleClose={() =>
              setLocationInfo({
                open: false,
                list: [],
              })
            }
            locationList={locationInfo.list}
            handleCommandCentre={handleCommandCentre}
          />
        )}
      </>
    );
  }
);

Header.displayName = 'Header';

export default Header;
